class CustomCollectionFilter extends HTMLElement {
  constructor() {
    super()
    this.panel = this.querySelector(".custom-filter__panel")
    this.overlay = this.querySelector(".custom-filter__panel-overlay")
    this.form = this.querySelector(".custom-filter__form")
  }

  connectedCallback() {

    this.trigger = this.querySelector(".custom-filter__trigger")
    this.closeButtons = this.querySelectorAll(".custom-filter__panel-close, .js-close-panel-button")



    this.applyButton = this.form.querySelector('button[type="submit"]')
    this.applyCount = this.form.querySelector(".custom-filter__apply-count")

    this.openPanel = this.openPanel.bind(this)
    this.closePanel = this.closePanel.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.updateApplyButtonState = this.updateApplyButtonState.bind(this)

    this.trigger.addEventListener("click", this.openPanel)
    this.overlay.addEventListener("click", this.closePanel)

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", this.closePanel)
    })

    this.form.addEventListener("submit", this.onFormSubmit)
    this.form.addEventListener("change", this.updateApplyButtonState)

    this.updateApplyButtonState()
  }

  openPanel(event) {
    event.preventDefault()
    this.panel.hidden = false
    this.overlay.hidden = false
    document.body.style.overflow = "hidden"

    requestAnimationFrame(() => {
      this.panel.classList.add("is-open")
    })
  }

  closePanel(event) {
    if (event) event.preventDefault()

    this.panel.classList.remove("is-open")
    document.body.style.overflow = ""

    const onTransitionEnd = () => {
      this.panel.hidden = true
      this.overlay.hidden = true
      this.panel.removeEventListener("transitionend", onTransitionEnd)
    }
    this.panel.addEventListener("transitionend", onTransitionEnd)
  }

  updateApplyButtonState() {
    if (!this.applyButton || !this.applyCount) return
    const checkedInputs = this.form.querySelectorAll('input[type="checkbox"]:checked')
    const checkedCount = checkedInputs.length
    if (this.applyCount) {
      this.applyCount.textContent = `(${checkedCount})`
    }
    this.applyButton.disabled = checkedCount === 0
  }

  onFormSubmit(event) {
    event.preventDefault()
    const formData = new FormData(this.form)
    const searchParams = new URLSearchParams(formData)
    const finalParams = new URLSearchParams()
    for (const [key, value] of searchParams.entries()) {
      if (value) {
        finalParams.append(key, value)
      }
    }
    if (this.applyButton) {
      this.applyButton.disabled = true
      this.applyButton.textContent = "Lade..."
    }
    window.location.href = `${window.location.pathname}?${finalParams.toString()}`
  }
}

if (!customElements.get("custom-collection-filter")) {
  customElements.define("custom-collection-filter", CustomCollectionFilter)
}
